module.exports = __webpack_public_path__ + "img/circular-tick-icon.2ba86770.svg";